import React from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export const DetailsWarranty = (props: any) => {
  const [serviceLevel, setServiceLevel] = React.useState<string | null>(null);
  const [serviceType, setServiceType] = React.useState<string | null>(null);
  const [deliverables, setDeliverables] = React.useState<string | null>(null);
  const [startDate, setStartDate] = React.useState<string | null>(null);
  const [endDate, setEndDate] = React.useState<string | null>(null);
  const [warrantyType, setWarrantyType] = React.useState<string | null>(null);
  const [referenceNo, setReferenceNo] = React.useState<string | null>(null);
  const [status, setStatus] = React.useState<string | null>(null);
  const {t} = useTranslation();

  React.useEffect(() => {
    if (!props.data || !props.flag || !props.type) return;
    const formatDate = (dateString: string): string => {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    };
    setWarrantyType(props.type);
    props.data.forEach((value: any) => {
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      const endDateFormatted = formatDate(value.EndDate);
      if (value.EntitlementType.toLowerCase().includes(props.flag)) {
        setReferenceNo(value.ContractEntitlementId || "");
        setStartDate(value.StartDate || "");
        setEndDate(value.EndDate);
        // Generate Service Type

        if (value.Offers && value.Offers.length > 0) {
          const serviceTypeString = value.Offers.map(
            (offer: any) => offer.PackageName
          ).join(" ");
          setServiceType(serviceTypeString);
        }
        if (value.Offers && value.Offers.length > 0) {
          const deliverablesString = value.Offers.flatMap(
            (offer: any) =>
              offer.Delieverables?.map(
                (deliverable: any) => deliverable.DeliverableName
              ) || []
          )
            .filter(Boolean) // Remove any null or undefined values
            .join(" ");

          setDeliverables(deliverablesString);
        }

        if (value.Offers && value.Offers.length > 0) {
          const serviceLevelString = value.Offers.flatMap(
            (offer: any) =>
              offer.Modifiers?.map(
                (modifier: any) => modifier.ModifierDescription
              ) || []
          )
            //.filter(Boolean) // Remove any null or undefined values
            .join(" ");
          setServiceLevel(serviceLevelString);
        }
        // Generate Status
        if (value.Status) {
          const formattedStatus = value.Status.toLowerCase();
          switch (formattedStatus) {
            case "active":
              
              setStatus(
                `<span class="spnActive text-success"> <strong>${value.Status} : </strong>Covered under Manufacturer warranty, Expiration Date:  <strong>${endDateFormatted} </strong> </span>`
              );
              break;
            case "expired":
              setStatus(
                `<span class="spnExpired text-danger"> <strong className='failCase'>${value.Status}</strong><span className='failCase'> Manufacturer warranty has expired , Expiration Date :  </span><strong className='failCase'>${endDateFormatted}</strong></span>`
              );
              break;
            case "pending":
              setStatus("Pending");
              break;
            default:
              setStatus("Unspecified");
          }
        }
      }
    });
  }, []);

  return (
    <div className="contract-details">
      <div className="info-wrapper">
        <Row>
          <Col sm={3}>
            <label className="label-regular">{t('HPI.Product.Warranty.Warrantytype',{defaultValue:'Warranty type'})}</label>
          </Col>
          <Col sm={8}>
            <p className="body-regular">{warrantyType}</p>
          </Col>
        </Row>
      </div>

      <div className="info-wrapper">
        <Row>
          <Col sm={3}>
            <label className="label-regular">{t('HPI.Product.Warranty.Referencenumber',{defaultValue:'Reference number'})}</label>
          </Col>
          <Col sm={8}>
            <p className="body-regular">{referenceNo}</p>
          </Col>
        </Row>
      </div>

      <div className="info-wrapper">
        <Row>
          <Col sm={3}>
            <label className="label-regular">{t('HPI.Product.Warranty.Servicetype',{defaultValue:'Service type'})}</label>
          </Col>
          <Col sm={8}>
            <p
              className="body-regular"
              dangerouslySetInnerHTML={{ __html: serviceType || "" }}
            />
          </Col>
        </Row>
      </div>

      <div className="info-wrapper">
        <Row>
          <Col sm={3}>
            <label className="label-regular">{t('HPI.Product.productdetails.Status',{defaultValue:'Status'})}</label>
          </Col>
          <Col sm={8}>
            <p
              className="body-regular"
              dangerouslySetInnerHTML={{ __html: status || "" }}
            />
          </Col>
        </Row>
      </div>

      <div className="info-wrapper">
        <Row>
          <Col sm={3}>
            <label className="label-regular">{t('HPI.Product.Warranty.StartDate',{defaultValue:'Start date'})}</label>
          </Col>
          <Col sm={8} className="body-regular">
            {startDate}
          </Col>
        </Row>
      </div>

      <div className="info-wrapper">
        <Row>
          <Col sm={3}>
            <label className="label-regular">{t('HPI.Entitlement.EntitleDetails.Enddate',{defaultValue:'End date'})}</label>
          </Col>
          <Col sm={8} className="body-regular">
            {endDate}
          </Col>
        </Row>
      </div>

      <div className="info-wrapper">
        <Row>
          <Col sm={3}>
            <label className="label-regular">{t('HPI.Product.Warranty.Servicelevel',{defaultValue:'Service level'})}</label>
          </Col>
          <Col sm={8} className="body-regular">
            <p
              className="body-regular"
              dangerouslySetInnerHTML={{ __html: serviceLevel || "" }}
            ></p>
          </Col>
        </Row>
      </div>
      <div className="info-wrapper">
        <Row>
          <Col sm={3}>
            <label className="label-regular">{t('HPI.Product.Warranty.Deliverables',{defaultValue:'Deliverables'})}</label>
          </Col>
          <Col sm={8} className="body-regular">
            <p
              className="body-regular"
              dangerouslySetInnerHTML={{ __html: deliverables || "" }}
            ></p>
          </Col>
        </Row>
      </div>
    </div>
  );
};
